import type { MessageKey } from '../en';

export const es: Partial<Record<MessageKey, string>> = {
  'shell.tagline': "Ubicación simulada, fácil",
  'shell.closeMenu': "Cerrar menú",
  'shell.accountMenu': "Menú de la cuenta",
  'shell.expandSidebar': "Expandir barra lateral",
  'shell.collapseSidebar': "Contraer barra lateral",
  'shell.mainNav': "Principal",
  'shell.openMenu': "Abrir menú",
  'shell.welcome': "¡Hola de nuevo, {name}!",
  'shell.there': "amigo",
  'shell.dashboardSubtitle': "Gestiona ubicaciones simuladas, listas, itinerarios y más desde un solo lugar.",
  'shell.searchLabel': "Buscar ubicaciones, listas, itinerarios, artículos",
  'shell.searchPlaceholder': "Buscar ubicaciones, listas, itinerarios, artículos...",
  'shell.searchResults': "Resultados de búsqueda",
  'shell.noMatches': "Sin coincidencias",
  'shell.pages': "Páginas",
  'shell.recent': "Recientes",
  'shell.notificationsUnread': "Notificaciones, {count} sin leer",
  'shell.viewAllNotifications': "Ver todas las notificaciones",
  'shell.notifications': "Notificaciones",
  'shell.accountMenuNamed': "Menú de la cuenta, {name}",
  'shell.account': "Cuenta",
  'shell.logOut': "Cerrar sesión",
  'shell.goPremium': "Hazte Premium",
  'shell.unlimitedCoins': "Monedas ilimitadas",
  'shell.unlimitedEverything': "Todo ilimitado",
  'shell.devicesLimit': "Úsalo en hasta 3 dispositivos",
  'shell.upgradeNow': "Mejorar ahora",
  'shell.themeToLight': "Cambiar al tema claro",
  'shell.themeToDark': "Cambiar al tema oscuro",
  'shell.themeLightTitle': "Tema claro",
  'shell.themeDarkTitle': "Tema oscuro",
  'nav.dashboard': "Panel",
  'nav.dashboard.desc': "Resumen de ubicaciones, listas, rutas y actividad de la cuenta.",
  'nav.stationary': "Puntos fijos",
  'nav.stationary.desc': "Ubicaciones simuladas fijas guardadas en esta cuenta.",
  'nav.playlist': "Listas",
  'nav.playlist.desc': "Conjuntos ordenados de ubicaciones simuladas.",
  'nav.itinerary': "Itinerarios",
  'nav.itinerary.desc': "Crea, edita y gestiona tus rutas guardadas.",
  'nav.articles': "Artículos",
  'nav.articles.desc': "Guías de configuración, reproducción y sincronización.",
  'nav.joystick': "Sesiones de joystick",
  'nav.joystick.desc': "Rutas de reproducción, estadísticas y sesiones de joystick guardadas.",
  'nav.history': "Historial de ubicación",
  'nav.history.desc': "Lugares que esta cuenta ha simulado.",
  'nav.coins': "Mock Coins",
  'nav.coins.desc': "Desglose completo del uso de monedas en módulos y actividades.",
  'nav.devices': "Gestionar dispositivos",
  'nav.devices.desc': "Revisa los dispositivos con sesión iniciada en tu cuenta de MockLoc.",
  'nav.backup': "Copia y sincronización",
  'nav.backup.desc': "Estado de la copia en la nube y la sincronización.",
  'nav.analytics': "Analítica",
  'nav.analytics.desc': "Entiende tu actividad en MockLoc, el uso de red y la salud de la sincronización.",
  'nav.whatsNew': "Novedades de la app",
  'nav.whatsNew.desc': "Actualizaciones, correcciones y mejoras recientes de MockLoc.",
  'nav.notifications': "Notificaciones",
  'nav.notifications.desc': "Alertas de sincronización, copia y producto.",
  'nav.account': "Cuenta",
  'nav.account.desc': "Perfil, Premium y datos de inicio de sesión.",
  'nav.help': "Ayuda y soporte",
  'nav.help.desc': "Sigue las conversaciones y recibe ayuda del equipo de MockLoc.",
  'nav.settings': "Ajustes",
  'nav.settings.desc': "Tema, idioma y valores predeterminados de la app móvil.",
  'settings.back': "Ajustes",
  'settings.backDefaults': "Valores de la app móvil",
  'settings.theme.shellTitle': "Tema",
  'settings.theme.shellDesc': "Tamaño del texto, colores, claro u oscuro y fuente de este navegador.",
  'settings.language.shellTitle': "Idioma",
  'settings.language.shellDesc': "Elige el idioma de este sitio.",
  'settings.defaults.shellTitle': "Valores de la app móvil",
  'settings.defaults.shellDesc': "Valores que la app del teléfono usa para mapas, puntos, rutas y reproducción.",
  'settings.home.theme.title': "Ajustes de tema",
  'settings.home.theme.desc': "Tamaño del texto, colores, claro u oscuro y fuente de este navegador.",
  'settings.home.language.title': "Ajustes de idioma",
  'settings.home.language.desc': "Elige el idioma del menú, los títulos de página y los ajustes.",
  'settings.home.defaults.title': "Valores de la app móvil",
  'settings.home.defaults.desc': "Valores de mapa, punto fijo, lista, itinerario, joystick y reproductor de la app del teléfono.",
  'language.lead': "Inglés (Estados Unidos) es el idioma predeterminado. Tu elección se guarda en este navegador.",
  'language.searchLabel': "Buscar idiomas",
  'language.searchPlaceholder': "Buscar idiomas",
  'language.listLabel': "Idiomas",
  'language.defaultBadge': "Predeterminado",
  'language.empty': "Ningún idioma coincide con esa búsqueda.",
  'language.previewLabel': "Vista previa",
  'language.preview': "Ubicaciones simuladas, listas y rutas.",
  'theme.manager': "Gestor de tema",
  'theme.lead': "Elige el tamaño del texto, el color, el modo claro u oscuro y la fuente de este navegador. 100 % coincide con las pantallas de hoy. Las muestras de aquí y el resto del sitio se actualizan juntos.",
  'theme.resetAll': "Restablecer todo",
  'theme.previewKicker': "Vista previa en vivo",
  'theme.previewTitle': "Ubicaciones simuladas",
  'theme.previewBold': "Lista preparada",
  'theme.previewBody': "Ubicaciones guardadas en esta cuenta.",
  'theme.previewHelp': "Conjuntos ordenados de ubicaciones simuladas.",
  'theme.text.title': "Texto",
  'theme.text.lead': "Cada rol tiene un tamaño compartido. La muestra muestra ese rol. Los controles de esta página mantienen un tamaño fijo para que sigan siendo fáciles de usar.",
  'theme.resetText': "Restablecer texto",
  'theme.whereLabel': "Dónde se usa.",
  'theme.changesLabel': "Qué cambia.",
  'theme.sizeAria': "Tamaño de {title}",
  'theme.text.header.title': "Encabezado",
  'theme.text.header.sample': "Puntos fijos",
  'theme.text.header.where': "Títulos de página, titulares principales, títulos de estados vacíos y números grandes, como el saldo de monedas.",
  'theme.text.header.changes': "Texto de 20 px o más.",
  'theme.text.bold.title': "Negrita",
  'theme.text.bold.sample': "Hazte Premium",
  'theme.text.bold.where': "Títulos de tarjetas, el nombre de la marca, encabezados de sección y botones grandes.",
  'theme.text.bold.changes': "Texto de 15 px a 18 px.",
  'theme.text.normal.title': "Normal",
  'theme.text.normal.sample': "Ubicaciones guardadas en esta cuenta.",
  'theme.text.normal.where': "Etiquetas de navegación, botones normales, títulos de lista y resúmenes cortos.",
  'theme.text.normal.changes': "Texto de 14 px.",
  'theme.text.descriptive.title': "Descriptivo",
  'theme.text.descriptive.sample': "Conjuntos ordenados de ubicaciones simuladas.",
  'theme.text.descriptive.where': "Subtítulos, texto de ayuda, insignias, pies y líneas secundarias.",
  'theme.text.descriptive.changes': "Texto de 12 px a 13 px.",
  'theme.text.other.title': "Otro",
  'theme.text.other.sample': "Actualizado hace 2 horas",
  'theme.text.other.where': "Rótulos, marcas de tiempo, etiquetas de gráficos y pies de foto.",
  'theme.text.other.changes': "Texto de 9 px a 11 px. Las marcas de menos de 9 px se quedan fijas.",
  'theme.color.title': "Color",
  'theme.color.lead': "Los colores integrados siguen siendo distintos en claro y oscuro hasta que eliges uno. Tu elección se usa en ambos temas. Los colores guardados en un punto, una lista o una ruta se quedan como se guardaron.",
  'theme.resetColors': "Restablecer colores",
  'theme.colorAria': "Color de {title}",
  'theme.hexAria': "Hex de {title}",
  'theme.custom': "Personalizado",
  'theme.builtin': "Integrado",
  'theme.reset': "Restablecer",
  'theme.color.primary.title': "Primario",
  'theme.color.primary.where': "Botones, el elemento activo del menú, enlaces y el morado de la marca.",
  'theme.color.primary.changes': "Morado sólido, texto morado claro y fondos morados suaves.",
  'theme.color.accent.title': "Acento",
  'theme.color.accent.where': "Destacados dorados en el inicio de sesión, artículos e insignias.",
  'theme.color.accent.changes': "El dorado de la marca y rellenos dorados claros, incluidos los detalles pequeños de las ilustraciones.",
  'theme.color.info.title': "Info",
  'theme.color.info.where': "Estado azul, enlaces informativos y marcas de información.",
  'theme.color.info.changes': "El azul usado para información en claro y oscuro.",
  'theme.color.success.title': "Éxito",
  'theme.color.success.where': "Sincronizado, completo y estado positivo.",
  'theme.color.success.changes': "Texto de estado verde y marcas de éxito.",
  'theme.color.warning.title': "Aviso",
  'theme.color.warning.where': "Alertas, marcas de monedas y destacados Premium.",
  'theme.color.warning.changes': "Avisos ámbar y el dorado usado en las monedas.",
  'theme.color.danger.title': "Peligro",
  'theme.color.danger.where': "Errores, eliminaciones y el punto de no leído.",
  'theme.color.danger.changes': "Texto de error rojo y acciones destructivas.",
  'theme.mode.title': "Tema",
  'theme.mode.lead': "La misma elección de claro y oscuro que el botón de la barra superior.",
  'theme.mode.group': "Tema",
  'theme.mode.dark': "Oscuro",
  'theme.mode.light': "Claro",
  'theme.mode.darkHint': "Superficies tenues y texto claro.",
  'theme.mode.lightHint': "Superficies brillantes y texto oscuro.",
  'theme.font.title': "Fuente",
  'theme.font.lead': "Se usa una sola familia en todo el sitio. Los titulares de marketing vuelven a Plus Jakarta Sans cuando se elige Inter. Los pesos de abajo son los que la interfaz ya usa.",
  'theme.resetFont': "Restablecer fuente",
  'theme.font.group': "Fuente",
  'theme.font.sample': "Ubicaciones simuladas, fáciles",
  'theme.font.inter.note': "Fuente que el sitio usa hoy. Regular hasta Black están cargadas.",
  'theme.font.google-sans.note': "El archivo Regular cubre 400 y 500. El archivo Bold cubre de 600 a 900.",
  'theme.font.helvetica.note': "Usa Helvetica en este dispositivo, luego Helvetica Neue y después Arial.",
  'theme.font.arial.note': "Regular y Bold son tipos instalados. Los demás pesos se sintetizan.",
  'theme.weight.regular': "Regular",
  'theme.weight.medium': "Media",
  'theme.weight.semibold': "Seminegrita",
  'theme.weight.bold': "Negrita",
  'theme.weight.extrabold': "Extra negrita",
  'theme.weight.black': "Black",
  'theme.weight.sample': "Ubicaciones simuladas, listas y rutas",
  'theme.face.gsRegular': "Google Sans Regular",
  'theme.face.gsBold': "Google Sans Bold",
  'theme.face.arialRegular': "Arial Regular",
  'theme.face.arialBold': "Arial Bold",
  'theme.face.arialSynth': "Sintetizado desde Arial",
  'theme.face.helveticaRegular': "Helvetica Regular",
  'theme.face.helveticaOther': "Helvetica o sintetizada",
  'theme.face.inter': "Inter {weight}",
  'defaults.browserChip': "Este navegador",
  'defaults.syncNote': "Guardado en este navegador por ahora. La app del teléfono usará estos valores cuando la sincronización esté conectada.",
  'defaults.sectionDefaults': "Valores de la app",
  'defaults.sectionDefaultsDesc': "Define valores para una experiencia más rápida y fluida",
  'defaults.sectionPlayer': "Reproductor",
  'defaults.sectionPlayerDesc': "Ajustes de superposición y reproducción",
  'defaults.reset': "Restablecer",
  'defaults.map.title': "Google Map",
  'defaults.map.desc': "Cómo se abren los mapas nuevos",
  'defaults.stationary.title': "Punto fijo",
  'defaults.stationary.desc': "Valores para puntos nuevos del mapa",
  'defaults.playlist.title': "Lista",
  'defaults.playlist.desc': "Valores para pines nuevos de la lista",
  'defaults.itinerary.title': "Itinerario",
  'defaults.itinerary.desc': "Valores para tramos nuevos de ruta",
  'defaults.joystick.title': "Joystick",
  'defaults.joystick.desc': "Valores para sesiones de joystick",
  'defaults.player.title': "Reproductor",
  'defaults.player.desc': "Controles del reproductor superpuesto y de la simulación",
  'defaults.summary.zoom': "zoom {n}",
  'defaults.summary.playerAll': "Todas las superposiciones activas",
  'defaults.summary.playerOff': "Superposiciones desactivadas",
  'defaults.summary.playerSome': "{on} de 4 activas",
  'defaults.section.location': "Contexto de ubicación",
  'defaults.section.map': "Mapa",
  'defaults.section.camera': "Cámara",
  'defaults.section.history': "Historial",
  'defaults.section.search': "Búsqueda",
  'defaults.section.view': "Mapa",
  'defaults.section.playlist': "Lista",
  'defaults.section.motion': "Movimiento",
  'defaults.section.style': "Estilo",
  'defaults.section.appearance': "Apariencia",
  'defaults.section.overlay': "Reproductor superpuesto",
  'defaults.actual.title': "Tu ubicación real",
  'defaults.actual.desc': "Se usa para buscar lugares mientras simulas",
  'defaults.actual.empty': "Aún no se ha guardado",
  'defaults.actual.emptyHint': "Permite la ubicación y abre la app sin simulación para capturarla.",
  'defaults.actual.refresh': "Actualizar ahora",
  'defaults.actual.pending': "El teléfono guarda esta ubicación. La sincronización aún no está conectada.",
  'defaults.mapTheme.title': "Tema del mapa",
  'defaults.mapTheme.desc': "Aspecto de las pantallas de mapa nuevas",
  'defaults.mapTheme.group': "Tema del mapa",
  'defaults.zoom.title': "Nivel de zoom predeterminado",
  'defaults.zoom.desc': "Zoom inicial de los mapas nuevos",
  'defaults.tilt.title': "Inclinación predeterminada de la cámara",
  'defaults.tilt.desc': "Ángulo de la cámara en las pantallas de mapa",
  'defaults.degrees': "{n}°",
  'defaults.meters': "{n} m",
  'defaults.seconds': "{n} s",
  'defaults.kilometers': "{n} km",
  'defaults.speedValue': "{n} {unit}",
  'defaults.range.zoomMin': "10",
  'defaults.range.zoomMax': "20",
  'defaults.range.tiltMin': "0°",
  'defaults.range.tiltMax': "65°",
  'defaults.range.accuracyMin': "0 m",
  'defaults.range.accuracyMax': "300 m",
  'defaults.range.searchMin': "3 km",
  'defaults.range.searchMax': "50 km",
  'defaults.range.timeMin': "0 s",
  'defaults.range.timeMax': "600 s",
  'defaults.range.plAccuracyMin': "0 m",
  'defaults.range.plAccuracyMax': "500 m",
  'defaults.range.joyAccuracyMin': "1 m",
  'defaults.range.joyAccuracyMax': "100 m",
  'defaults.range.itinAccuracyMin': "1",
  'defaults.range.itinAccuracyMax': "100",
  'defaults.theme.silver': "Plata",
  'defaults.theme.silverDesc': "Estilo gris claro, cómodo a la luz del día.",
  'defaults.theme.night': "Noche",
  'defaults.theme.nightDesc': "Colores oscuros del mapa para poca luz y sesiones nocturnas.",
  'defaults.theme.retro': "Retro",
  'defaults.theme.retroDesc': "Tonos cálidos de época, con un aire de mapa clásico.",
  'defaults.theme.standard': "Estándar",
  'defaults.theme.standardDesc': "Colores clásicos de Google Maps, con verdes y azules conocidos.",
  'defaults.accuracy.title': "Precisión GPS predeterminada",
  'defaults.accuracy.desc': "Precisión usada para puntos nuevos del historial",
  'defaults.nameFormat.title': "Formato de fecha",
  'defaults.nameFormat.desc': "Nombre predeterminado de los puntos fijos",
  'defaults.nameFormat.dialogTitle': "Elige el formato del nombre del punto",
  'defaults.nameFormat.dialogSubtitle': "La vista previa usa la fecha de hoy. Elige un formato compacto para los puntos nuevos.",
  'defaults.nameFormat.group': "Formato de fecha",
  'defaults.search.title': "Radio de búsqueda",
  'defaults.search.stationary': "Se priorizan resultados cercanos alrededor de tu pin",
  'defaults.search.playlist': "Se priorizan resultados cercanos alrededor del centro del mapa",
  'defaults.search.itinerary': "Se priorizan resultados cercanos alrededor del centro del mapa",
  'defaults.tray.title': "Altura de la bandeja",
  'defaults.tray.stationaryDesc': "Tamaño visible del panel en el mapa",
  'defaults.tray.playlistDesc': "Panel visible de listas en el mapa",
  'defaults.tray.group': "Altura de la bandeja",
  'defaults.tray.small': "Pequeña",
  'defaults.tray.medium': "Media",
  'defaults.tray.large': "Grande",
  'defaults.view.historyTitle': "Vista del historial",
  'defaults.view.historyDesc': "Cómo se muestran los puntos guardados",
  'defaults.view.playlistTitle': "Vista de listas",
  'defaults.view.playlistDesc': "Cómo se muestran las listas guardadas",
  'defaults.view.group': "Vista",
  'defaults.view.list': "Lista",
  'defaults.view.grid': "Cuadrícula",
  'defaults.time.title': "Tiempo por elemento",
  'defaults.time.desc': "Espera antes de pasar al siguiente pin",
  'defaults.plAccuracy.title': "Precisión por elemento",
  'defaults.plAccuracy.desc': "Precisión GPS aplicada a cada pin de la lista",
  'defaults.speed.title': "Velocidad predeterminada",
  'defaults.speed.desc': "Velocidad de reproducción de los tramos nuevos",
  'defaults.unit.title': "Unidad de velocidad",
  'defaults.unit.itineraryDesc': "Muestra las velocidades en km/h o mph en el módulo de itinerario",
  'defaults.unit.group': "Unidad de velocidad",
  'defaults.unit.kmh': "km/h",
  'defaults.unit.mph': "mph",
  'defaults.itinAccuracy.title': "Precisión",
  'defaults.itinAccuracy.desc': "Precisión GPS de los tramos nuevos",
  'defaults.color.title': "Color de la ruta",
  'defaults.color.desc': "Color de la línea de las rutas nuevas",
  'defaults.color.group': "Color de la ruta",
  'defaults.joySpeed.title': "Velocidad predeterminada",
  'defaults.joySpeed.desc': "Velocidad inicial al crear una sesión de joystick",
  'defaults.joyUnit.desc': "Muestra y controla las velocidades del joystick en km/h o mph",
  'defaults.joyAccuracy.title': "Precisión GPS predeterminada",
  'defaults.joyAccuracy.desc': "Precisión GPS inicial al crear una sesión de joystick",
  'defaults.joyName.title': "Formato de fecha",
  'defaults.joyName.desc': "Nombre predeterminado de las sesiones nuevas de joystick",
  'defaults.joyName.dialogTitle': "Elige el formato del nombre de la sesión",
  'defaults.marker.title': "Marcador predeterminado",
  'defaults.marker.desc': "Se usa al crear una sesión de joystick. Puedes cambiarlo en cada sesión.",
  'defaults.marker.group': "Marcador predeterminado",
  'defaults.marker.maps': "Maps",
  'defaults.marker.car': "Coche",
  'defaults.marker.waze': "Waze",
  'defaults.polyline.title': "Color predeterminado de la polilínea",
  'defaults.polyline.desc': "Color predeterminado de la ruta dibujada durante una sesión de joystick.",
  'defaults.polyline.group': "Color de la polilínea",
  'defaults.overlay.stationary.title': "Punto fijo",
  'defaults.overlay.stationary.desc': "Reproductor flotante cuando la simulación fija sigue en segundo plano",
  'defaults.overlay.playlist.title': "Lista",
  'defaults.overlay.playlist.desc': "Reproductor flotante cuando la simulación de lista sigue en segundo plano",
  'defaults.overlay.itinerary.title': "Itinerario automático",
  'defaults.overlay.itinerary.desc': "Reproductor flotante cuando la simulación de itinerario sigue en segundo plano",
  'defaults.overlay.joystick.title': "Joystick",
  'defaults.overlay.joystick.desc': "Joystick flotante cuando la sesión sigue en segundo plano",
  'defaults.format.dayShort': "Día y fecha · 12 h",
  'defaults.format.fullDay': "Fecha completa · 12 h",
  'defaults.format.shortDayYear': "Día, fecha, año · 24 h",
  'defaults.format.dayMonthYear': "Fecha, año · 12 h",
  'defaults.format.eu': "Fecha UE · 24 h",
  'defaults.format.us': "Fecha EE. UU. · 12 h",
  'defaults.format.iso': "Fecha ISO · 24 h",
  'defaults.format.timeFirst': "Hora primero · 24 h",
  'defaults.format.monthFirst': "Mes primero · 24 h",
  'defaults.format.withSeconds': "Con segundos · 12 h",
  'defaults.close': "Cerrar",
};
